import openErrorModal from "../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../Error/ErrorUtilities";
import { fetchUpdateItemModal, updateItem } from "../HTTPRequests/ItemRequests";
import Mediator from "../Utilities/Mediator";
import DeleteItemModal from "./DeleteItemModal";
import ItemBaseModal from "./ItemBaseModal";

export default class UpdateItemModal extends ItemBaseModal {
	modalDiv: HTMLDivElement;

	constructor() {
		super();
		this.modalDiv = document.createElement('div');
	}

	public addUpdateModalsClickListeners() {
		const updateIcons: NodeListOf<HTMLTableRowElement> = document.querySelectorAll('#items tbody tr');
		updateIcons.forEach(icon => {
			icon.onclick = () => {
				if (icon.id) {
					document.body.append(this.loadingScreen);
					this.fetchModal(icon);
				}
			}
		});
	}

	private fetchModal(image: HTMLTableRowElement) {
		fetchUpdateItemModal(image.id)
			.then((response: string) => {
				this.openModal(response, image.id);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openModal(modalHTMLString: string, id: string) {
		document.body.appendChild(this.modalDiv);
		this.modalDiv.innerHTML = modalHTMLString;

		new DeleteItemModal(id, this.modalDiv).addDeleteModalClickListener();
		this.addSubItemsModalEventsListeners(this.modalDiv);
		this.saveSubItems();
		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners(id);
	}

	private addModalButtonsClickListeners(id: string) {
		const imageLabel: HTMLLabelElement = this.modalDiv.querySelector("#pic + label");
		const img: HTMLImageElement = this.modalDiv.querySelector('img[alt="close icon"]');
		const saveButton: HTMLButtonElement = this.modalDiv.querySelector('#save');

		imageLabel.onclick = () => {
			imageLabel.style.display = 'none';
		}

		document.body.onclick = (event) => {
			if (event.target === this.modalDiv.firstElementChild
				&& !this.modalDiv.lastElementChild.classList.contains('choose-item__open')) {
				this.modalDiv.remove();
			}
		}

		img.onclick = () => {
			this.modalDiv.remove();
		}

		saveButton.onclick = () => {
			this.saveSubItems();
			const errorMessage: HTMLParagraphElement = this.modalDiv.querySelector('ul + p');
			if (this.subitemsIdsArray.length == 1) {
				errorMessage.style.display = "block";
			} else {
				errorMessage.style.display = "none";
				this.saveUpdatedItem(id);
			}
		}
	}

	private saveUpdatedItem(id: string) {
		let { valid, itemFormData } = this.ModalData;
		if (valid) {
			document.body.append(this.loadingScreen);
			itemFormData.append("id", id);
			this.updateItem(itemFormData);
		} else {
			this.form.reportValidity();
		}
	}

	private updateItem(itemFormData: FormData) {

		updateItem(itemFormData, this.updateImage)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("itemCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}
